module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loanListTitle":"Loans","newLoanLink":"+ New loan"},"et":{"loanListTitle":"Loans","newLoanLink":"+ New loan"},"ru":{"loanListTitle":"Loans","newLoanLink":"+ New loan"}}')
  delete Component.options._Ctor
}
